/** 数据列表展示字段（与表格列一致，不含「操作」列），供高级查询等复用 */
export const LIST_FIELD_OPTIONS: { value: string; label: string }[] = [
  { value: 'contractAttachment', label: '合同附件' },
  { value: 'orderAttachment', label: '订单附件' },
  { value: 'receiptAttachment', label: '收款附件' },
  { value: 'logisticsAttachment', label: '物流附件' },
  { value: 'invoiceAttachment', label: '发票附件' },
  { value: 'id', label: '数据项ID' },
  { value: 'name', label: '数据名称' },
  { value: 'source', label: '来源' },
  { value: 'type', label: '类型' },
  { value: 'documentStatus', label: '单据状态' },
  { value: 'onChain', label: '上链状态' },
  { value: 'contractNo', label: '合同号' },
  { value: 'contractType', label: '合同类型' },
  { value: 'customer', label: '客户' },
  { value: 'settlementOrg', label: '结算组织' },
  { value: 'productName', label: '商品名称' },
  { value: 'rwaCategory', label: '业务分类' },
  { value: 'priceTaxTotal', label: '价税合计' },
  { value: 'receiptAmount', label: '收款金额' },
  { value: 'partialReceipt', label: '部分收款' },
  { value: 'unreceivedAmount', label: '未收款金额' },
  { value: 'invoicedAmount', label: '已开票额' },
  { value: 'contractCreatedDate', label: '合同创建日期' },
  { value: 'contractReceiptDate', label: '合同收款日期' },
  { value: 'status', label: '状态' },
  { value: 'createdTime', label: '创建时间' },
]
